const firebaseConfig = {
  apiKey: "AIzaSyC3zHOrL2h51TdNHwHHlfnwfJIv5Mb9KhI",
  authDomain: "esch-2022.firebaseapp.com",
  databaseURL: "https://esch-2022.firebaseio.com",
  projectId: "esch-2022",
  storageBucket: "esch-2022.appspot.com",
  messagingSenderId: "61495580797",
  appId: "1:61495580797:web:6a762e6fa11a0508ef7914",
  measurementId: "G-5WQ1YVTEGR"
};

export { firebaseConfig }
